export default {
  enum: {
    position: 'Pozycja (dostawca)',
    purchaser: 'Zamawiający (klient)',
    dictionaryValue: 'Wartość słownikowa',
    brand: 'Brand',
    permission: 'Uprawnienie (dostęp)',

    projects: 'Projekty',
    campaigns: 'Kampanie',

    pl: 'Polski',
    en: 'Angielski',

    standard: 'Standardowa',
    commission: 'Prowizja',
    transferredCommission: 'Prowizja-Transferowana',
    technicalCost: 'Koszt techniczny',

    new: 'Nowy',
    completed: 'Zrealizowany',
    accepted: 'Zaakceptowany',
    rejected: 'Odrzucony',

    notSent: 'Niewysłany',
    sent: 'Wysłany',
    error: 'Błąd',
    ok: 'OK',
    duplicate: 'Duplikat',

    acceptedByClient: 'Zaakceptowany przez klienta',
    readyForInvoice: 'Gotowy do fakturowania',
    invoiced: 'Zafakturowany',
    corrected: 'Korygowany',
    settled: 'Rozliczony',
    cancelled: 'Anulowany',
    withdrawn: 'Cofnięty',

    foreign: 'Zagraniczna',
    domestic: 'Krajowa',

    draft: 'Szkic',
    generated: 'Zatwierdzona',
    sentShe: 'Wysłana',
    paid: 'Zapłacona',
    inKSeF: 'W KSeF',

    open: 'Wprowadzona',
    approved: 'Zatwierdzona',

    bankTransfer: 'Przelew',
    compensation: 'Kompensata',
    prepayment: 'Przedpłata',
    paidIt: 'Zapłacono',

    newPlural: 'Nowe',
    acceptedPlural: 'Zaakceptowane',
    rejectedPlural: 'Odrzucone',
    toBeCorrected: 'Wymaga korekty',

    budget: 'Budżetem',
    project: 'Projektem',
    purchaseInvoice: 'Fakturą sprzedaży',
    estimateItemCommentMediaplanner:
      'Komentarzem mediaplanera do pozycji w kampanii',
    estimateItemCommentFinance: 'Komentarzem finansów do pozycji w kampanii',
    estimateByMonthMediaplanner:
      'Komentarzem mediaplanera do profilu w kampanii',
    estimateByMonthFinance: 'Komentarzem finansów do profilu w kampanii',
    contract: 'Zleceniem',
    signedContract: 'Podpisanym zleceniem',
    employeeSign: 'Podpisem pracownika',
    salesInvoice: 'Fakturą sprzedaży (załącznik email)',
    sentEmail: 'Wysłanym e-mailem',

    statusReversal: 'Cofnięcie statusu',
    automaticOperation: 'Operacja automatyczna',
    automaticallyApproved: 'Faktura została automatycznie zatwierdzona',
    revertFromApproved: 'Faktura została cofnięta ze stanu Zatwierdzona',
    revertFromSent: 'Faktura została cofnięta ze stanu Wysłana',

    sales: 'Sprzedaż',
    purchase: 'Zakup',

    projectNoun: 'Kampania',
    purchaseInvoiceNoun: 'Faktura zakupu',
    saleInvoiceNoun: 'Faktura sprzedaży',
    specialInvoicingNoun: 'Niestandardowe fakturowanie',

    delayed: 'Opóźniony',
    toCancel: 'Do anulowania',
    dateChange: 'Zmiana okresu',
    all: 'Wszystkie',

    others: 'Standardowy',
    tvBuying: 'TV Zakup',
    MPC: 'MPC',

    paymentStatusPaid: 'Opłacona',
    paymentStatusPartiallyPaid: 'Opłacona częściowo',
    paymentStatusPending: 'Oczekuje na płatność',
    paymentStatusOverdue: 'Po terminie',
    paymentStatusOverduePartiallyPaid: 'Po terminie, opłacona częściowo',

    applications: 'Wniosek',
    positionAppForeign: 'Wniosek o pozycję zagraniczną',
    applicationExecutions: 'Realizacja wniosku',
    orders: 'Zamówienie',
    ordersRemind: 'Zamówienie - przypomnienie',
    orderExecutions: 'Realizacja zamówienia',
    orderExecutionsRemind: 'Realizacja zamówienia - przypomnienie',
    unblockEstimateByMonth: 'Wniosek o odblokowanie sprzedaży/zakupu',
    projectsDelayed: 'Założenie kampanii/projektu po terminie',
    projectsToCancel: 'Anulowanie kampanii/projektu',
    purchaseDeficiencies: 'Wyjaśnianie braków zakupowych',
    specialInvoicing: 'Niestandardowe fakturowanie',
    salesInvoicing: 'Sprzedaż - zafakturowanie',
    noPurchaserInOrder: 'Brak zamawiającego w zamówieniu',
    purchaserCreatedInOrder: 'Automatyczne dodanie zamawiającego',
    purchaserEditedInOrder: 'Automatyczna edycja zamawiającego',
    tooManyPurchasersInOrder: 'Zbyt wielu zamawiających w zamówieniu',
    contractImportError: 'Problemy przy imporcie zleceń',
    contractsWaitingToSign: 'Zlecenia oczekujące na podpisanie',
    projectDateChange: 'Zmiana terminu kampanii/projektu',
    cyclicJobError: 'Błąd zadania cyklicznego',
    mirrorProject: 'Automatyczne utworzenie kampanii refakturowej',

    salesInvoiceToContractor: 'Faktura sprzedaży do kontrahenta',
    salesInvoiceDuplicateToContractor:
      'Duplikat faktury sprzedaży do kontrahenta',
    surveyToClient: 'Ankieta do klienta',
    excelImport: 'Import z Excela',
    signedContracts: 'Podpisane zlecenia',
    contractSignedNotSent: 'Podpisane zlecenia do ręcznej wysyłki',
    contractUnsigned: 'Odmowa podpisania zleceń',
    fvzTeamReminder: 'Przypomnienie dla zespołu o FVZ',
    mirrorProjectError: 'Błąd automatycznego utworzenia kampanii refakturowej',

    orderExecutionReminder: 'Realizacja zamówienia - przypomnienie',
    orderReminder: 'Zamówienie - przypomnienie',
    dailyFVZReminder: 'FVZ - przypomnienie dzienne',
    weekFVZReminder: 'FVZ - przypomnienie tygodniowe',
    externalContractsImport: 'Zlecenia zewnętrzne - import',
    deleteBlockadeMonthException:
      'Automatyczne usuwanie wyjątków do blokad miesięcznych',
    waitingContractsToSign: 'Oczekujące zlecenia do podpisania',
    reportEstimateItemsDataRawToGoogleDrive: 'Surówka - zapis do Google Drive',
    eodClients: 'EOD - eksport danych klientów',
    eodDocuments: 'EOD - import / eksport FVZ i dekretacji',
    importKSeFFromSymphonyHandel: 'Import KSeF z Symfonii Handel',
    exportSalesInvoicesToSymphony:
      'Eksport faktur sprzedaży do Symfonii Handel',
    generateSurveyForClients: 'Ankiety - przygotowanie dla klientów',
    sendSurveyToClients: 'Ankiety - wysyłka do klientów',
    backupSurowkaToGoogleDrive: 'Surówka - backup do Google Drive',
    refreshSalesInvoicePayments: 'Wpłaty FVS - odświeżenie danych',
    syncFromOneTool: 'OneTool - synchronizacja zespołów i pracowników',

    poland: 'Polska',
    unitedStates: 'Stany Zjednoczone',
    germany: 'Niemcy',

    entered: 'Wprowadzone',
    waitingForSigning: 'Oczekujące na podpisanie',
    signed: 'Podpisane',
    unsigned: 'Odmowa podpisania',

    dateOfIssue: 'wg daty wystawienia',
    dateOfSale: 'wg daty sprzedaży',
    dateOfProject: 'wg daty mediaplanu',

    campaignCompletion: 'Uzupełnienie kampanii',
    contracts: 'Zlecenia',
    intercompanyOrders: 'Zamówienia międzyspółkowe',
    campaignSettlement: 'Rozliczenie kampanii',
    notStarted: 'Nie rozpoczęto',
    inProgress: 'Zaplanowany',
    notApplicable: 'Nie dotyczy',

    nextMonthEnd: 'Koniec następnego miesiąca',
    currentMonthEnd: 'Koniec bieżącego miesiąca',
    lastMonthEnd: 'Koniec poprzedniego miesiąca',
    fifteenthOfCurrentMonth: '15-ty dzień bieżącego miesiąca',
    fifteenthOfNextMonth: '15-ty dzień następnego miesiąca',
    sinceProjectCreation: 'Od utworzenia projektu/kampanii',

    high: 'Wysoki',
    medium: 'Średni',
    low: 'Niski',

    scopeGlobal: 'Globalny',
    scopeCompany: 'Spółka',
    scopePurchaser: 'Zamawiający',

    onceAYear: 'Raz w roku',
    semiAnnually: 'Półrocznie',
    quarterly: 'Kwartalnie',
    monthly: 'Miesięcznie',

    allShe: 'Wszyscy',
    purchaserShort: 'Zamawiający',
    supplier: 'Dostawcy',
    clientsGroup: 'Grupy kontrahentów',

    text: 'Tekst',
    yesNo: 'Tak/Nie',
    yesNoText: 'Tak/Nie + tekst',

    yes: 'Tak',
    no: 'Nie',
    // Timeline steps translations
    atLeastOneProfilePerMonth: 'Przynajmniej jeden profil w miesiącu',
    noMediaplanForMediaProfileInCurrentMonth:
      'Brak mediaplanu dla profilu mediowego w bieżącym miesiącu',
    atLeastOneItemAdded: 'Dodano przynajmniej jedną pozycję',
    mediaplanApprovedByClient: 'Mediaplan zaakceptowany przez klienta',
    specialInvoicingRequest: 'Wniosek o niestandardowe fakturowanie',
    allItemsWithAmountsEnteredForCurrentMonth:
      'Wszystkie pozycje z kwotami wprowadzonymi dla bieżącego miesiąca',
    projectCancelledRequest: 'Wniosek o anulowanie kampanii/projektu',
    projectDateChangeRequest: 'Wniosek o zmianę daty kampanii/projektu',
    requiredCampaignDocumentsAdded:
      'Wymagane dokumenty projektu/kampanii dodane',
    checkContractsCoverage: 'Pozycje bez zlecenia',
    contractsSignedByResponsiblePerson:
      'Zlecenia podpisane przez osobę odpowiedzialną',
    contractSent: 'Zlecenie wysłane',
    orderCreatedForDeliveryTeam:
      'Zamówienie utworzone dla zespołu realizującego',
    orderApprovedByDeliveryTeam:
      'Zamówienie międzyspółkowe zatwierdzone przez zespół realizujący',
    orderExecutionCreated: 'Utworzono realizację zamówienia',
    orderExecutionApproved: 'Realizacja zamówienia zatwierdzona',
    orderExecutionPositionsSumValidation:
      'Niezgodna suma pozycji realizacji zamówienia',
    monthlySettlementReminder: 'Przypomnienie o rozliczeniu miesięcznym',
    currentMonthReadyForInvoicing: 'Bieżący miesiąc gotowy do fakturowania',
    statusConfirmedByDocuments: 'Status potwierdzony dokumentami',
    salesSettlementCompleted: 'Rozliczenie sprzedaży zakończone',
    pendingFVZAssignedToCampaign:
      'Oczekujące FVZ przypisane do projektu/kampanii',
    missingFVZ: 'Brakujące FVZ',
    purchaseSettlementCompleted: 'Rozliczenie zakupów zakończone',
    campaignsWithBlockingInvoicingErrors:
      'Projekty/kampanie z blokującymi błędami fakturowania',
    salesInvoiceSent: 'Faktura sprzedaży wysłana',
    mediaplanCorrection: 'Korekta mediaplanu',
    timelineError: 'Uwagi',
  },
  param: {
    lastProcessedDocumentsDate: 'Data ostatniego przetworzenia dokumentów',
    lastProcessedClientsDate: 'Data ostatniego przesłania klientów',
    turnOffPurchaseInvoiceDomestic: 'Wyłącz dodawanie FVZ krajowych',
    daysToCancelFVZNumber:
      'Liczba dni od utworzenia FVZ do możliwości anulowania FVZ',
    umpRequestUserForDebug: 'DEBUG: Użytkownik na którego idzie request do UMP',
    umpLogs: 'DEBUG: Włącz logi UMP',
    eod: 'EOD',
    fvz: 'FVZ',
    ump: 'UMP',
    newPositionApplicationUrl: 'URL do wniosku o nową pozycję',
    surowkaFromYear: 'Surówka - rok początkowy generowania raportów',
    surowkaBaseName: 'Surówka - bazowa nazwa pliku (bez roku i rozszerzenia)',
    surowkaBackupSubfolder:
      'Surówka - nazwa podfolderu backupu na Google Drive',
    surowka: 'Surówka',
    system: 'Systemowe',
    api: 'API',
    mirrorProjectResponsibleUser:
      'Użytkownik odpowiedzialny za kampanie refakturowe',
    contractsForWorkUrl: 'Zgłoszenie umów o dzieło - URL',
    surveyEmailMessagePl: 'Domyślna treść wiadomości email do ankiety (PL)',
    surveyEmailMessageEng: 'Domyślna treść wiadomości email do ankiety (ENG)',
    mediaplannerApiProjectsByTeamsForCompanies:
      'Mediaplanner API projekty wg zespołów - dozwolone w spółkach',
    mirrorProject: 'Kampanie refakturowe',
    mirrorProjectProfileName:
      'Kampanie refakturowe - nazwa profilu wyzwalającego',
    mirrorProjectCompanySysNumber:
      'Kampanie refakturowe - numer systemowy spółki docelowej',
    mirrorProjectTeamSysNumber:
      'Kampanie refakturowe - numer systemowy zespołu',
  },
} as const;
